import moment from 'moment';
import PropTypes from 'prop-types';
import React from 'react';
import { ButtonToolbar, DropdownButton, MenuItem, OverlayTrigger, Popover, } from 'react-bootstrap';
import { humanize, titleize } from 'underscore.string';
import { withTranslation } from 'react-i18next';
import DatePicker from 'components/time/datepicker';
import { sluggify } from 'utils/localization/utils';
import { withLocaleContext } from 'providers/locale-settings-context';
function getInitialState(props) {
    return {
        filterFor: props.startKey,
        start: props.initialStart || moment().subtract(7, 'days'),
        end: props.initialEnd || moment().endOf('day'),
    };
}
class DateRangeFilter extends React.Component {
    constructor(props) {
        super(props);
        this.onDropdownSelect = (value) => {
            const state = Object.assign({}, this.state, { filterFor: value });
            this.setState(state);
        };
        this.onCreate = () => {
            this.refs.overlayTrigger.hide();
            this.props.onChange({
                filterType: this.state.filterFor,
                start: this.state.start,
                end: this.state.end,
            });
        };
        this.renderPopupDropdown = () => {
            const { t } = this.props;
            const { customSearchFields, startKey, endKey, hideActionDropDown } = this.props;
            if (hideActionDropDown) {
                return null;
            }
            if (customSearchFields && customSearchFields.length) {
                return customSearchFields.map((field) => {
                    return (React.createElement(MenuItem, { eventKey: field, onSelect: (value) => this.onDropdownSelect(value) }, titleize(t(sluggify(humanize(field))))));
                });
            }
            return (React.createElement(React.Fragment, null,
                React.createElement(MenuItem, { eventKey: startKey, onSelect: (value) => this.onDropdownSelect(value) }, titleize(t(sluggify(startKey)))),
                React.createElement(MenuItem, { eventKey: endKey, onSelect: (value) => this.onDropdownSelect(value) }, titleize(t(sluggify(endKey))))));
        };
        this.state = getInitialState(props);
    }
    onStartDateChange(value) {
        const state = Object.assign({}, this.state, { start: moment(value) });
        this.setState(state);
    }
    onEndDateChange(value) {
        const state = Object.assign({}, this.state, {
            end: moment(value).endOf('day'),
        });
        this.setState(state);
    }
    onClear() {
        this.refs.overlayTrigger.hide();
        const initialState = getInitialState(this.props);
        this.props.onChange({
            filterType: 'clear',
            start: initialState.start,
            end: initialState.end,
        });
        this.setState(() => {
            return initialState;
        });
    }
    renderPopup() {
        const { t } = this.props;
        return (React.createElement(Popover, { style: { zIndex: this.props.zIndex }, id: "date-range-popup" },
            React.createElement("div", { className: "clearfix date-range-filter-wrapper" },
                (this.props.endKey || this.props.customSearchFields) && (React.createElement("div", { className: "dropdown-filter mb-4" },
                    React.createElement(DropdownButton, { id: "date-filter-type", bsStyle: "default", bsSize: "small", title: titleize(t(sluggify(this.state.filterFor))) }, this.renderPopupDropdown()))),
                React.createElement("div", { className: "date-picker-group" },
                    React.createElement(DatePicker, { label: titleize(t('FROM')), locale: this.props.localeData.languageCodeId, eventKey: "start", initialDate: this.state.start, onChange: (value) => this.onStartDateChange(value), maxDate: this.props.maxStart })),
                React.createElement("div", { className: "date-picker-group" },
                    React.createElement(DatePicker, { label: titleize(t('TO')), locale: this.props.localeData.languageCodeId, eventKey: "end", initialDate: this.state.end, onChange: (value) => this.onEndDateChange(value), maxDate: this.props.maxEnd })),
                React.createElement(ButtonToolbar, null,
                    this.props.isClearEnabled && (React.createElement("button", { className: "button button-secondary", onClick: () => this.onClear() }, titleize(t('CLEAR')))),
                    React.createElement("button", { className: "button button-green", onClick: () => this.onCreate() }, this.props.updateBool
                        ? t('UPDATE_DATE_FILTER')
                        : t('ADD_DATE_FILTER'))))));
    }
    render() {
        const { t } = this.props;
        return (React.createElement("div", { className: this.props.className },
            React.createElement(OverlayTrigger, { rootClose: true, className: this.props.className, ref: "overlayTrigger", trigger: "click", placement: this.props.popoverPlacement, overlay: this.renderPopup() },
                React.createElement("button", { className: this.props.buttonClassName }, this.props.label || t('FILTER_DATES')))));
    }
}
DateRangeFilter.propTypes = {
    startKey: PropTypes.string,
    endKey: PropTypes.string,
    initialStart: PropTypes.object,
    initialEnd: PropTypes.object,
    onChange: PropTypes.func.isRequired,
    className: PropTypes.string,
    buttonClassName: PropTypes.string,
    maxStart: PropTypes.object,
    maxEnd: PropTypes.object,
    zIndex: PropTypes.string,
    popoverPlacement: PropTypes.string,
    customSearchFields: PropTypes.array,
    isClearEnabled: PropTypes.bool,
};
DateRangeFilter.defaultProps = {
    initialStart: null,
    initialEnd: null,
    maxStart: new Date(8640000000000000),
    maxEnd: new Date(8640000000000000),
    zIndex: 'auto',
    popoverPlacement: 'bottom',
    buttonClassName: 'w-36 justify-center flex button button-green',
    isClearEnabled: true,
};
export default withTranslation()(withLocaleContext(DateRangeFilter));
